import React from 'react';
import { CloseIcon } from '../icons/CloseIcon.jsx';
import CollapsedFormWrapper from '../CollapsedFormWrapper.jsx';

const closeBtnStyle = {
  padding: '4px',
  lineHeight: '12px',
  background: 'none',
};

const employeeItemStyle = {
  paddingLeft: '4px',
  background: '#F7FAFD',
  border: '1px solid #DFE2E5',
  borderRadius: '3px',
};

const EmployeesSelected = ({ selected, handleSelect }) => {
  const renderEmployeeItem = ({ id, fullName, name, archived }) => {
    return (
      <div
        key={`employee-${id}`}
        className="flex m-t-4 m-l-4"
        style={employeeItemStyle}
      >
        <span>
          {archived ? `${fullName || name} (archived)` : fullName || name}
        </span>
        <span
          className="btn btn-clear"
          style={closeBtnStyle}
          onClick={() => handleSelect({ id })}
        >
          <CloseIcon />
        </span>
      </div>
    );
  };

  return selected.length ? (
    <CollapsedFormWrapper
      entities={selected}
      limit={16}
      duplicateBtnLimit={160}
      component={(props) => renderEmployeeItem(props)}
    />
  ) : null;
};

export default EmployeesSelected;
